import { useDialog } from "@/client/stores/dialog";
import { FilterBonusRefType, FilterResumeType } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Form,
  FormField,
  FormItem,
  FormLabel,
  Input,
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  FormControl,
  SelectValue,
  SelectTrigger,
  ScrollArea,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";
import { useFilterResumeStore } from "@/client/stores/filter-resume";
import { usefilterUser } from "@/client/services/user/filter-user";
import { Role } from "@reactive-resume/utils";
import { useFilterBonusRef, useFilterRate } from "@/client/stores/filter";
import { FilterRateType } from "libs/dto/src/rate";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
export type RateFormType = {
  name?: {
    condition: StringFilterCondition;
    value: string;
  };
  price?: {
    condition: NumberFilterCondition;
    value: string;
  };
  credit?: {
    condition: NumberFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: RateFormType) => {
  const filter: FilterRateType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || !field.value) return;

    filter[key as keyof RateFormType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterRateDialog = () => {
  type FormValue = RateFormType;

  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilter } = useFilterRate();
  let { open, isOpen, mode, close } = useDialog("filter-rate");
  const form = useForm<FormValue>({
    defaultValues: {
      name: {
        condition: "equals",
        value: "",
      },
      price: {
        condition: "equals",
        value: "",
      },
      credit: {
        condition: "equals",
        value: "",
      },
    },
  });
  const OnSubmit = (data: FormValue) => {
    try {
      data.name!.condition = "equals";
      console.log(data);
      const filter = ObjectConversionToFilterType(data);
      replaceFilter(filter);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Filtrer les tarifs</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Nom"
                  form={form}
                  condition="String"
                  nameField="name.condition"
                  disabled={true}
                />
                <Input {...form.register("name.value")} />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Prix"
                  form={form}
                  condition="Number"
                  nameField="price.condition"
                />
                <Input {...form.register("price.value")} type="number" />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Credit"
                  form={form}
                  condition="Number"
                  nameField="credit.condition"
                />
                <Input {...form.register("credit.value")} type="number" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
